const _ = require('lodash');

const defaultState = {
    inboxInstructionsTerm: [],
    ruleDay25: '',
    ruleDay23: '',
    loading: false,
    errors:{}
}
  
  export default (state=defaultState, action={}) => {
    switch (action.type) {
      case 'FETCH_INSTRUCTIONS_FULFILLED': {
        
        let arrayMain=[];
        let lastId = -1;
        let newItem = {};
        
        if(Array.isArray(action.payload.data)){
            action.payload.data.forEach((element,index) => {
                if(element.ID !== lastId){//novo elemento
                    if(lastId !== -1){//adiciona o ultimo ID construido, sem ser na primeira iteração em que o array está vazio
                        arrayMain.push(newItem);
                    }
                    newItem={};//limpa para criar um novo
                    lastId = element.ID;//modifica o ID pai a tratar
                    newItem["ID_PAI"] = element.ID;
                    newItem["ORDER_PHO"] = element.ORDER_PHO;
                    newItem["ID_GU"] = element.ID_GU;
                    newItem["COD_SIME"] = element.COD_SIME;
                    newItem["STATUS"] = element.STATUS;
                    newItem["VERSION_ID"] = element.VERSION_ID;
                    newItem["BEGIN_DATE"] = element.BEGIN_DATE;
                    newItem["TR_BAND"] = element.TR_BAND;
                    if(element.COMMENTS){
                    newItem["COMMENTS"] = element.COMMENTS;
                    }else{
                    newItem["COMMENTS"] = '';
                    }
                    newItem["H" + element.HOUR_BLOCK + "STATE"] = element.OBJ_STATE;
                    newItem["H" + element.HOUR_BLOCK + "ENERGY"] = element.OBJ_ENERGY;
                    newItem["H" + element.HOUR_BLOCK + "FLAG_DETAIL"] = element.FLAG_DETAIL;
                    newItem["H" + element.HOUR_BLOCK + "WARNING"] = false;
                }else{
                    newItem["H" + element.HOUR_BLOCK + "STATE"] = element.OBJ_STATE;
                    newItem["H" + element.HOUR_BLOCK + "ENERGY"] = element.OBJ_ENERGY;
                    newItem["H" + element.HOUR_BLOCK + "FLAG_DETAIL"] = element.FLAG_DETAIL;
                    newItem["H" + element.HOUR_BLOCK + "WARNING"] = false;
                }
            });
            var newItemKeys = Object.keys(newItem);
            
            if(newItemKeys.length > 0){//guarda para apenas adicionar a lista caso n esteja vazia
                arrayMain.push(newItem);
            }
        }else{
            console.log('FETCH_INSTRUCTIONS_FULFILLED error: ');
            console.dir(action.payload.data);
        }

        //ordenar os registos
        let orderedInstructions = _.orderBy(arrayMain, ['COD_SIME','ID_PAI'], ['asc','desc']);
         
        return {
          ...state,
          inboxInstructionsTerm: orderedInstructions,
          loading: false,
          errors: {}
        }
      }
  
      case 'FETCH_INSTRUCTIONS_PENDING': {
        return {
          ...state,
          loading: true,
          errors: {}
        }
      }
  
      case 'FETCH_INSTRUCTIONS_REJECTED': {
        return {
          ...state,
          loading: false,
          errors: { global: action.payload.message }
        }
      }

      case 'ADD_INSTRUCTIONS_TERM_PROD_FULFILLED': {

        let filteredInstructions;
        let auxDate = action.date;//buscar a data das IDs mostradas agora. Apenas inserimos no state as IDs criadas se estivermos no mesmo dia
        let userCompany = action.userCompany.substring(0,4);//para aparecerem apenas os registos das IDs das centrais ao qual o user pertence
    
        filteredInstructions = _.filter(action.newInstructions,
            function(item) {
              //item.COMMENTS = '';
              if (item.BEGIN_DATE === auxDate && item.COD_SIME.substring(0,4) === userCompany) {
                      return true;
              }
            }
        );

        let mergedInstructions = [...state.inboxInstructionsTerm, ...filteredInstructions];
        let orderedInstructions = _.orderBy(mergedInstructions, ['COD_SIME','ID_PAI'], ['asc','desc']);

        return {
            ...state,
            //instructions: state.instructions.push({id:action.itemId,item:action.item,completed:action.completed})
            inboxInstructionsTerm: orderedInstructions
        } 	
      }

      case 'EDIT_INSTRUCTION_TERM_FULFILLED': {
        const id = action.instruction.ID_PAI;
        const newItem = action.instruction;
        let finalList = [];

        // Step 1. Remove previous previous version of ID
        // Step 2. Add new version
        state.inboxInstructionsTerm.forEach(element => {

          if (element.ID_PAI === id ) {
            finalList.push(newItem);
          }
          else {
            finalList.push(element);
          }
          
        });

        return {
          ...state,
          inboxInstructionsTerm: finalList
        }        
      }
      
      case 'ACCEPT_INSTRUCTION_TERM_FULFILLED': {       
        const id = action.instructionId;
        const idCodSime = action.instructionCod_Sime;
        const date = action.instructionDate;
        const comments = action.instructionComments;
        let finalList = [];


        // Step 1. Remove previous validated for the same generation unit
        // Step 2. Change the staus of the new one to "validated"
        state.inboxInstructionsTerm.forEach(element => {

          if (element.ID_PAI === id ) {
            finalList.push({...element, STATUS: 'ACEITE', COMMENTS: comments});
          }
          else if ( !((element.COD_SIME === idCodSime) && (element.STATUS === 'ACEITE' || element.STATUS === 'ACEITE-RECLAMADA') && (element.BEGIN_DATE === date))) {
            finalList.push(element);
          }      
        });

        return {
          ...state,
          inboxInstructionsTerm: finalList
        }
      }

      case 'REJECT_INSTRUCTION_TERM_FULFILLED': {
        const id = action.instructionId;
        const comments = action.instructionComments;
        let status = 'RECLAMADA';

        return {
            ...state,
            inboxInstructionsTerm: state.inboxInstructionsTerm.map(item => item.ID_PAI === id ?  {...item, STATUS: status, COMMENTS: comments} : item)
        }
      }

      case 'BAN_INSTRUCTION_TERM_FULFILLED': { 
        const id = action.instructionId;
        const idCodSime = action.instructionCod_Sime;
        const date = action.instructionDate;
        const comments = action.instructionComments;
        let finalList = [];


        // Step 1. Remove previous validated for the same generation unit
        // Step 2. Change the staus of the new one to "validated"
        state.inboxInstructionsTerm.forEach(element => {

          if (element.ID_PAI === id ) {
            finalList.push({...element, STATUS: 'ACEITE-RECLAMADA', COMMENTS: comments});
          }
          else if ( !((element.COD_SIME === idCodSime) && (element.STATUS === 'ACEITE'|| element.STATUS === 'ACEITE-RECLAMADA') && (element.BEGIN_DATE === date))) {
            finalList.push(element);
          }      
        });

        return {
          ...state,
          inboxInstructionsTerm: finalList
        }
      }

      case 'CANCEL_INSTRUCTION_TERM_FULFILLED':{
        const id = action.instructionId;
        return {
            ...state,
            inboxInstructionsTerm: state.inboxInstructionsTerm.filter(item => item.ID_PAI !== id)
        }
      }

      case 'FETCH_RULE_INSTRUCTIONS_PROD_FULFILLED': {
        
        return {
          ...state,
          ruleDay23: action.payload.data[0].RULE_VALUE,
          ruleDay25: action.payload.data[1].RULE_VALUE,
          errors: {},
          loading: false
        }
      }

      default:
        return state;
    }
  }



// WEBPACK FOOTER //
// ./src/reducers/production-term-reducer.js